import { useEffect, useState } from 'react'

/** Architecture §11: the slow-network notice shows after this long pending. */
export const SLOW_AFTER_MS = 5000

/**
 * `useSlow(isPending, 5000)` (Frontend §4.8): true once `pending` has stayed true for `ms`; false again as soon as it
 * ends. A new pending period starts the wait again.
 */
export function useSlow(pending: boolean, ms: number = SLOW_AFTER_MS): boolean {
  const [slow, setSlow] = useState(false)
  useEffect(() => {
    if (!pending) return
    const t = setTimeout(() => {
      setSlow(true)
    }, ms)
    return () => {
      clearTimeout(t)
      setSlow(false)
    }
  }, [pending, ms])
  return pending && slow
}
